// "Hemen başlayın" adımları (docs/styleguide/baslangic.md). Hesap Doktor Takvimi'nden hazır açılır; adımlar kurulum
// istemez, kullanıcıya neler yapabileceğini gösterir. Her adım bir kez bakmakla biter: adımın bağlantısı açılınca
// personel için işaretlenir (StaffGettingStartedMark; anahtarlar VegaGettingStartedLogic'teki listeyle aynıdır).
// `menu`: hedef kullanıcının yan menüsünden alınır, menüde yoksa (izin, kapalı e-Nabız) adım ya da kısayol görünmez.
export const GETTING_STARTED_STEPS = [
  { key: 'Discover', icon: 'fa-regular fa-compass', site: true },
  { key: 'Docplanner', icon: 'fa-regular fa-calendar-check', menu: 'sidebar.customerList' },
  { key: 'Modules', icon: 'fa-regular fa-grid-2', shortcuts: true }
];

// Sıra tanıtım sitesindeki özellik sırasıdır; danışan kartı Docplanner adımındadır.
export const MODULE_SHORTCUTS = [
  { key: 'Calendar', icon: 'fa-regular fa-calendar-days', menu: 'sidebar.calendar' },
  { key: 'Sale', icon: 'fa-regular fa-cart-plus', menu: 'sidebar.billNew' },
  { key: 'ENabiz', icon: 'fa-regular fa-heart-pulse', menu: 'sidebar.eNabizTransfer' },
  { key: 'Reports', icon: 'fa-regular fa-chart-line', menu: 'sidebar.reports' }
];

// Tanıtım sitesinin özellikler sayfası; dil ön eki zorunludur.
export function vegaSiteUrl(locale) {
  return locale === 'en' ? 'https://vegamedi.com/en/features' : 'https://vegamedi.com/tr/ozellikler';
}

// Menü öğesinin bağlantısı; grup ise ilk alt bağlantısı (Raporlar). Grup da boş `{ name: null }` bağlantı taşır.
export function findMenuLink(items, name) {
  for (const item of items || []) {
    if (item.name === name) return ownLink(item) || firstLink(item.children);
    const found = findMenuLink(item.children, name);
    if (found) return found;
  }
  return null;
}

function ownLink(item) {
  return item.link && item.link.name ? item.link : null;
}

function firstLink(items) {
  for (const item of items || []) {
    const link = ownLink(item) || firstLink(item.children);
    if (link) return link;
  }
  return null;
}

// marks: sunucunun döndürdüğü işaret listesi (`status.marks`).
export function gettingStartedSteps(menu, marks) {
  const seen = new Set(marks || []);
  return GETTING_STARTED_STEPS
    .map((step) => {
      const shortcuts = step.shortcuts
        ? MODULE_SHORTCUTS.map(s => ({ ...s, to: findMenuLink(menu, s.menu) })).filter(s => s.to)
        : null;
      return { ...step, to: step.menu ? findMenuLink(menu, step.menu) : null, shortcuts, done: seen.has(step.key) };
    })
    .filter(step => step.site || step.to || (step.shortcuts && step.shortcuts.length));
}
